<div class="modal-wrapper">
    <div class="title">{{'PTA.PtaCloseWhereToFind' | translate}}</div>
    <div class="text">{{'PTA.PtaCloseDescription' | translate}}</div>
    <div class="button-wrapper">
        <button class="c-btn c-btn--primary"  (click)="closeModal()">{{'PTA.PtaCloseOk' | translate}}</button>
    </div>
    <svg class="c-svg c-svg--close-24" (click)="closeModal()">
        <use xlink:href="#c-svg--close-24"></use>
    </svg>
</div>